export function Capitalize(str: string) {
  if (!str) return '';
  return str
    .toLowerCase()
    .split(' ')
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
}

export function cpfFix(value: number) {
  let fixed = String(value);

  while (fixed.length < 11) fixed = '0' + fixed;

  return fixed;
}

export function cnpjFix(value: string | number) {
  let fixed = String(value);

  while (fixed.length < 14) fixed = '0' + fixed;

  return fixed;
}

export function cepFix(value: number) {
  let fixed = String(value);

  while (fixed.length < 8) fixed = '0' + fixed;

  return fixed;
}

export function dateFix(value: number) {
  let fixed = String(value);

  while (fixed.length < 6) fixed = '0' + fixed;

  return fixed;
}

export function nthIndex(str: string, pat: string, n: number) {
  const L = str.length;
  let count = -1;
  while (n-- && count++ < L) {
    count = str.indexOf(pat, count);
    if (count < 0) break;
  }
  return count;
}

export function checkNewPos(str: string, pos: number, dir: number) {
  let aux = 0;
  aux = pos;

  if (aux === str.length) aux = -1;
  if (str[aux] && dir > 0)
    if ((str[aux].match(/[^0-9]/g) || []).length) aux += dir * 1;

  return aux;
}

export function checkNewPosReverse(str: string, pos: number, dir: number) {
  let aux = 0;
  aux = pos;

  if (aux === str.length) aux = -1;
  else {
    const resto = str.length - pos;

    if (str[aux] && dir > 0)
      if ((str[aux].match(/[^0-9]/g) || []).length) aux += dir * 1;
    aux = resto;
  }
  return aux;
}

export function mask(
  value: string | number | undefined,
  pattern: string,
  onlyNum?: boolean
) {
  if (value === undefined) return '';
  let i = 0;
  const innerValue = `${value}`;
  let valueLen = innerValue.length;
  const v = innerValue.toString();

  if (onlyNum === true && (innerValue.match(/[^0-9]/g) || []).length)
    valueLen--;

  let numero = pattern.length - (pattern.match(/#/g) || []).length;
  let newPattern = pattern;
  while (numero > 0) {
    newPattern += '#';
    numero--;
  }
  newPattern = newPattern
    .replace(/#/g, () => {
      if (i <= valueLen && newPattern[i] !== '#') {
        valueLen++;
      }
      return v[i++] || '';
    })
    .slice(0, Math.min(valueLen, pattern.length));

  if (newPattern[newPattern.length - 1] === pattern[newPattern.length - 1])
    return newPattern.slice(0, newPattern.length - 1);
  else return newPattern;
}

export function unMask(value: string, pattern: string) {
  if (value === undefined) return '';
  // const v = value.toString();

  const j = new RegExp(pattern);
  const newValue = value.split(j);
  const newString = newValue.join('');

  return newString;
}

export function telMask(value: string) {
  if (value === undefined) return '';
  let i = 0;
  const fixPattern = '(##) ####-####';
  const celPattern = '(##) #####-####';
  let pattern = fixPattern;
  const v = value.toString();

  const finalValue = unMask(v, '[^0-9]');
  let valueLen = finalValue.length;

  if (valueLen > 10) pattern = celPattern;

  let numero = pattern.length - (pattern.match(/#/g) || []).length;
  let newPattern = pattern;
  while (numero > 0) {
    newPattern += '#';
    numero--;
  }
  newPattern = newPattern
    .replace(/#/g, () => {
      if (i <= valueLen && newPattern[i] !== '#') {
        valueLen++;
      }
      return finalValue[i++] || '';
    })
    .slice(0, Math.min(valueLen, pattern.length));

  while (newPattern[newPattern.length - 1] === pattern[newPattern.length - 1]) {
    newPattern = newPattern.slice(0, newPattern.length - 1);
    if (newPattern.length === 0) break;
  }

  return newPattern;
}

export function cepMask(value: string) {
  if (value === undefined) return '';
  let i = 0;

  const v = value.toString();
  const pattern = '#####-###';

  const finalValue = unMask(v, '[^0-9]');
  let valueLen = finalValue.length;

  let numero = pattern.length - (pattern.match(/#/g) || []).length;
  let newPattern = pattern;
  while (numero > 0) {
    newPattern += '#';
    numero--;
  }
  newPattern = newPattern
    .replace(/#/g, () => {
      if (i <= valueLen && newPattern[i] !== '#') {
        valueLen++;
      }
      return finalValue[i++] || '';
    })
    .slice(0, Math.min(valueLen, pattern.length));

  if (newPattern[newPattern.length - 1] === pattern[newPattern.length - 1])
    return newPattern.slice(0, newPattern.length - 1);
  else return newPattern;
}

export function cpfMask(value: string) {
  if (value === undefined) return '';
  let i = 0;

  const v = value.toString();
  const pattern = '###.###.###-##';

  const finalValue = unMask(v, '[^0-9]');
  let valueLen = finalValue.length;

  let numero = pattern.length - (pattern.match(/#/g) || []).length;
  let newPattern = pattern;
  while (numero > 0) {
    newPattern += '#';
    numero--;
  }
  newPattern = newPattern
    .replace(/#/g, () => {
      if (i <= valueLen && newPattern[i] !== '#') {
        valueLen++;
      }
      return finalValue[i++] || '';
    })
    .slice(0, Math.min(valueLen, pattern.length));

  if (newPattern[newPattern.length - 1] === pattern[newPattern.length - 1])
    return newPattern.slice(0, newPattern.length - 1);
  else return newPattern;
}

export function cnpjMask(value: string) {
  if (value === undefined) return '';
  let i = 0;

  const v = value.toString();
  const pattern = '##.###.###/####-##';

  const finalValue = unMask(v, '[^0-9A-Za-z]').toUpperCase();
  let valueLen = finalValue.length;

  let numero = pattern.length - (pattern.match(/#/g) || []).length;
  let newPattern = pattern;
  while (numero > 0) {
    newPattern += '#';
    numero--;
  }
  newPattern = newPattern
    .replace(/#/g, () => {
      if (i <= valueLen && newPattern[i] !== '#') {
        valueLen++;
      }
      return finalValue[i++] || '';
    })
    .slice(0, Math.min(valueLen, pattern.length));

  if (newPattern[newPattern.length - 1] === pattern[newPattern.length - 1])
    return newPattern.slice(0, newPattern.length - 1);
  else return newPattern;
}

/**
 * Aplica a máscara certa a um documento que chega do back sem dizer se é CPF ou CNPJ.
 *
 * Desde o V83 do proposta-db as colunas de documento guardam o valor com zero-padding
 * em 14 posições, então o comprimento bruto deixou de distinguir os dois: o CPF
 * 31966284004 chega como "00031966284004" e caía no ramo do CNPJ, virando
 * "00.031.966/2840-04" na tela. A decisão passa a usar o comprimento SIGNIFICATIVO,
 * depois de tirar os zeros à esquerda — mesmo critério do CpfCnpjUtil no back.
 *
 * Preserva letras (CNPJ alfanumérico da IN 2.229/2024): documento com letra nunca
 * cai no ramo do CPF, porque a letra sobrevive ao strip.
 *
 * Limite conhecido: CNPJ com 11 ou menos dígitos significativos (ex. 00058163000125)
 * é indistinguível de um CPF por comprimento e sai com máscara de CPF. São 30 linhas
 * em 339.012 no PROD de 01/08 (0,009%); desambiguar exigiria validar o DV, que os
 * dados de teste do DEV não têm.
 */
export function cpfCnpjMask(value: string | number | null | undefined) {
  if (value === undefined || value === null) return '';

  const limpo = String(value).replace(/[^0-9A-Za-z]/g, '');
  if (limpo.length === 0) return '';

  const significativo = limpo.replace(/^0+(?=.)/, '');
  const ehCpf = significativo.length <= 11 && /^\d+$/.test(significativo);

  return ehCpf
    ? cpfMask(significativo.padStart(11, '0'))
    : cnpjMask(significativo.padStart(14, '0'));
}

export function cnaeMask(value: string) {
  if (value === undefined) return '';
  let i = 0;

  const v = value.toString();
  const pattern = '####-#/##';

  const finalValue = unMask(v, '[^0-9]');
  let valueLen = finalValue.length;

  let numero = pattern.length - (pattern.match(/#/g) || []).length;
  let newPattern = pattern;
  while (numero > 0) {
    newPattern += '#';
    numero--;
  }
  newPattern = newPattern
    .replace(/#/g, () => {
      if (i <= valueLen && newPattern[i] !== '#') {
        valueLen++;
      }
      return finalValue[i++] || '';
    })
    .slice(0, Math.min(valueLen, pattern.length));

  if (newPattern[newPattern.length - 1] === pattern[newPattern.length - 1])
    return newPattern.slice(0, newPattern.length - 1);
  else return newPattern;
}

export function dateMAMask(value: string) {
  if (value === undefined) return '';
  let i = 0;

  const v = value.toString();
  const pattern = '##/####';

  const finalValue = unMask(v, '[^0-9]');
  let valueLen = finalValue.length;

  let numero = pattern.length - (pattern.match(/#/g) || []).length;
  let newPattern = pattern;
  while (numero > 0) {
    newPattern += '#';
    numero--;
  }
  newPattern = newPattern
    .replace(/#/g, () => {
      if (i <= valueLen && newPattern[i] !== '#') {
        valueLen++;
      }
      return finalValue[i++] || '';
    })
    .slice(0, Math.min(valueLen, pattern.length));

  if (newPattern[newPattern.length - 1] === pattern[newPattern.length - 1])
    return newPattern.slice(0, newPattern.length - 1);
  else return newPattern;
}

export function dateDMAMask(value: string) {
  if (value === undefined) return '';
  let i = 0;

  const v = value.toString();
  const pattern = '##/##/####';

  const finalValue = unMask(v, '[^0-9]');
  let valueLen = finalValue.length;

  let numero = pattern.length - (pattern.match(/#/g) || []).length;
  let newPattern = pattern;
  while (numero > 0) {
    newPattern += '#';
    numero--;
  }
  newPattern = newPattern
    .replace(/#/g, () => {
      if (i <= valueLen && newPattern[i] !== '#') {
        valueLen++;
      }
      return finalValue[i++] || '';
    })
    .slice(0, Math.min(valueLen, pattern.length));

  if (newPattern[newPattern.length - 1] === pattern[newPattern.length - 1])
    return newPattern.slice(0, newPattern.length - 1);
  else return newPattern;
}

export function currencyFormat(value: number, decimal = false) {
  // let num = Number(value) || 0;
  // if (num === null) {
  //   return '0,00';
  // }
  // if (!decimal) {
  //   num = Math.floor(num);
  // }

  // let str = num
  //   .toLocaleString('pt-BR')
  //   .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');

  // if (decimal) {
  //   if (str[str.length - 2] === ',') str = str + '0';
  //   if (str[str.length - 3] !== ',') str = str + ',00';
  // }

  // return str;

  if (value === undefined) return '';

  let pattern = decimal ? '###.###.###.###.###,##' : '###.###.###.###.###';
  const reversePattern = decimal
    ? '##,###.###.###.###.###'
    : '###.###.###.###.###';
  let i = 0;
  const v = value.toString();

  const numNumbers = (v.match(/[0-9]/g) || []).length;

  const patternCutIndex = nthIndex(reversePattern, '#', numNumbers);
  const maxSize = decimal ? 4 : 1;

  let cutPattern = pattern.slice(
    pattern.length - Math.max(patternCutIndex + 1, maxSize),
    pattern.length
  );

  pattern = cutPattern;

  let finalValue = unMask(v, '[^0-9]');
  while (finalValue.length < maxSize) finalValue = '0' + finalValue;

  let valueLen = finalValue.length;
  if ((v.match(/[^0-9]/g) || []).length) valueLen--;

  let numero = cutPattern.length - (cutPattern.match(/#/g) || []).length;
  while (numero > 0) {
    cutPattern += '#';
    numero--;
  }
  cutPattern = cutPattern.replace(/#/g, () => {
    if (i <= valueLen && cutPattern[i] !== '#') {
      valueLen++;
    }

    return finalValue[i++] || '';
  });

  while (cutPattern[0] === '0') {
    if (cutPattern.length <= 4) break;
    cutPattern = cutPattern.slice(1, cutPattern.length);
  }

  return cutPattern;
}

export function currencyFormatV2(value: number) {
  if (!value) value = 0;

  const formattedValue = new Intl.NumberFormat('pt-br', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);

  return `R$ ${formattedValue}`;
}

export function currencyFormatWithCents(
  value: string | number,
  withRS = true
): string {
  if (value === undefined || value === null || value === '') return '';

  let numericValue = 0;

  if (typeof value === 'number') {
    numericValue = value;
  } else {
    const str = value.toString().trim();

    const noPrefix = str.replace(/[R$\s]/g, '');

    if (noPrefix === '') {
      numericValue = 0;
    } else if (/^\d+$/.test(noPrefix)) {
      numericValue = parseInt(noPrefix, 10) || 0;
    } else if (noPrefix.includes(',')) {
      const cleaned = noPrefix.replace(/\./g, '').replace(',', '.');
      numericValue = parseFloat(cleaned) || 0;
    } else if (noPrefix.includes('.')) {
      const dotCount = (noPrefix.match(/\./g) || []).length;
      if (dotCount > 1) {
        numericValue = parseFloat(noPrefix.replace(/\./g, '')) || 0;
      } else {
        const parts = noPrefix.split('.');
        if (parts[1] && parts[1].length === 2) {
          numericValue = parseFloat(noPrefix) || 0;
        } else {
          numericValue = parseFloat(noPrefix) || 0;
        }
      }
    } else {
      numericValue = parseFloat(noPrefix) || 0;
    }
  }

  const formatted = numericValue
    .toFixed(2)
    .replace('.', ',')
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return withRS ? `R$ ${formatted}` : formatted;
}

export function currencyMaskForInput(
  value: string | number,
  withRS = true
): string {
  if (value === undefined || value === null || value === '') return '';

  const cleaned = value.toString().replace(/\D/g, '');
  const numericValue = parseFloat(cleaned) / 100 || 0;

  const formatted = numericValue
    .toFixed(2)
    .replace('.', ',')
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return withRS ? `R$ ${formatted}` : formatted;
}

export function parseCurrencyToNumber(value: string): number {
  if (!value) return 0;
  return Number(value.replace(/[R$\s.]/g, '').replace(',', '.')) || 0;
}

export const DocumentProxyMask = (apiUrl: string) => {
  // return (
  //   'https://lojista.dev.gruposinosserra.com.br/documents/' +
  //   apiUrl.split('com/documents/')[1]
  // );
  if (apiUrl.split('com/documents/').length > 1)
    return '/documents/' + apiUrl.split('com/documents/')[1];
  else return apiUrl;
};
